/** Browser mirror of src/shared/voice.ts (Turbopack cannot import outside the web root); byte-pinned by webMirrorContracts. */
export const VOICE_CALL_SECONDS_BOUNDS = { min: 60, max: 1800 } as const;
export const VOICE_RING_SECONDS_BOUNDS = { min: 10, max: 120 } as const;
/** How many of the latest written messages a call is given; tool calls and results are never included. */
export const VOICE_CONTEXT_MESSAGES_BOUNDS = { min: 0, max: 30 } as const;
/** How long a call holds the line for the work it started before it hangs up and calls back; 0 never holds. */
export const VOICE_HOLD_SECONDS_BOUNDS = { min: 0, max: 300 } as const;
export const VOICE_CALL_RECORD_BOUNDS = { maxDurationMs: 1_800_000, maxEntries: 1000, maxEntryChars: 16_000, maxTranscriptChars: 200_000 } as const;
export const VOICE_AUDIO_FRAME_MAX_BYTES = 96_000;
export const VOICE_CONTROL_FRAME_MAX_BYTES = 16_384;
export { VOICE_SAMPLE_RATE } from '../../packages/plugin-shared/voicePcm.mjs';

/** The pauses a person may choose for ending a dictation by itself; `null` is the choice "never". */
export const VOICE_DICTATION_PAUSE_SECONDS = [3, 5, 10, 20] as const;
/** @externalConsumer Byte-pinned web/lib/voice.ts supplies the browser dictation default. */
export const VOICE_DICTATION_PAUSE_DEFAULT_SECONDS = 5;
const CALL_SESSION_DRAIN_MS = 15_000;
export const VOICE_CALL_STOP_BUDGET = {
  sessionDrainMs: CALL_SESSION_DRAIN_MS,
  /** Live shutdown must settle before the daemon's five-second pause barrier. */
  shutdownDrainMs: 3000,
  browserWaitMs: CALL_SESSION_DRAIN_MS + 1000,
} as const;
const DICTATION_FINAL_WAIT_MS = 3000;
const SESSION_DRAIN_MS = 2000;
/** One dictation stop budget: committed finals, shared upstream/usage drain, then browser transport margin. */
export const VOICE_DICTATION_STOP_BUDGET = {
  finalWaitMs: DICTATION_FINAL_WAIT_MS,
  sessionDrainMs: SESSION_DRAIN_MS,
  browserWaitMs: DICTATION_FINAL_WAIT_MS + SESSION_DRAIN_MS + 1000,
} as const;
